export function useNotifications() {
  const { getNotifications } = useStrapiService();
  const mainStore = useMainStore();
  const notifications = useState("notifications", () => null);

  const fetchNotifications = async () => {
    if (notifications.value) return notifications.value;

    const result = await getNotifications();
    if (result) {
      notifications.value = result;
      mainStore.setNotifications(result);
    }
    return result;
  };

  return {
    notifications,
    fetchNotifications,
  };
}
